import { Box, Button, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useContext, useState } from 'react';
import { openSnackbar } from 'store/slices/snackbar';
import { useDispatch } from 'store';
import useGrafSign, { GrafSign } from 'hooks/useGrafSign';
import { DrawsContext } from 'contexts/DrawsContext';
import DrawSignBox from './DrawSignBox';

type AddGraphSignsProps = {
    title: string;
    onClose: Function;
    sign?: GrafSign;
    forceDefault?: boolean;
};

const AddGraphSigns = ({ title, onClose, sign, forceDefault = false }: AddGraphSignsProps) => {
    const [drawnSign, setDrawnSign] = useState<any>();
    const intl = useIntl();
    const { addSign, updateSign } = useGrafSign();
    const dispatch = useDispatch();
    const { resetDraw } = useContext(DrawsContext);
    const [description, setDescription] = useState<string>(sign?.description || '');
    const [defaultSign, setDefaultSign] = useState<boolean>(sign?.default || false);

    function converMultiArray(final: any) {
        return final.reduce((acc: any, val: any) => (Array.isArray(val) ? acc.concat(converMultiArray(val)) : acc.concat(val)), []);
    }

    const handleAddSign = async () => {
        const puntos = converMultiArray(drawnSign?.toData());
        if (puntos.length > 20) {
            if (!sign) {
                await addSign({
                    points: puntos,
                    imageBase64: drawnSign?.getCanvas().toDataURL(),
                    description,
                    default: forceDefault || defaultSign
                });
            } else {
                await updateSign(sign._id, {
                    points: puntos,
                    imageBase64: drawnSign?.getCanvas().toDataURL(),
                    description,
                    default: forceDefault || defaultSign
                });
            }

            dispatch(
                openSnackbar({
                    open: true,
                    message: intl.formatMessage({ id: 'FIRMA_ANADIDA_CORRECTAMENTE' }),
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
            resetDraw && resetDraw();
            onClose();
        } else {
            dispatch(
                openSnackbar({
                    open: true,
                    message: intl.formatMessage({ id: 'POR_FAVOR_ANADA_UNA_FIRMA' }),
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };

    return (
        <>
            <Typography variant="h4" sx={{ mb: '20px', fontWeight: 600 }}>
                {title}
            </Typography>
            <DrawSignBox signCollector={(draw: any) => setDrawnSign(draw)}></DrawSignBox>{' '}
            <TextField
                sx={{ margin: '10px' }}
                fullWidth
                id="description"
                name="name"
                label={intl.formatMessage({ id: 'DESCRIPCION' })}
                type="text"
                value={description}
                onChange={(e) => {
                    e.target?.value?.length <= 50 && setDescription(e.target.value);
                }}
            />
            {forceDefault || (
                <FormControlLabel
                    name="defaultSign"
                    value={defaultSign}
                    onChange={() => setDefaultSign(!defaultSign)}
                    control={<Checkbox checked={defaultSign} />}
                    label={intl.formatMessage({ id: 'FIRMA_POR_DEFECTO' })}
                />
            )}
            <Box sx={{ alignSelf: 'flex-end', mt: '20px', pb: '20px' }}>
                <Button
                    sx={{ background: 'transparent', mr: '12px' }}
                    onClick={() => {
                        onClose(false);
                    }}
                >
                    {intl.formatMessage({ id: 'CANCELAR' })}
                </Button>
                <Button variant="contained" sx={{ minWidth: '150px', borderRadius: '4px' }} onClick={() => handleAddSign()}>
                    {intl.formatMessage({ id: 'GUARDAR' })}
                </Button>
            </Box>
        </>
    );
};

export default AddGraphSigns;
